module.exports = __webpack_public_path__ + "img/vertical_6_5_6005.7b0b2907.png";